export default {
  custom_allergen: {
    placeholder: 'Adaugă opțiune personalizată',
  },
  buttons: {
    add: 'Adaugă',
  },
};
